export default function CardTitle({
  children,
  className,
  rightSide,
}: {
  children: React.ReactNode;
  className?: string;
  rightSide?: React.ReactNode;
}) {
  return (
    <div
      className={`bg-[#F0F3F9] px-3 py-1.5 min-h-11 flex items-center justify-between rounded-md text-lg font-semibold text-display-body ${className}`}
    >
      {children}

      {rightSide}
    </div>
  );
}
